import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e70a21e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "vimeo-embed",
    style: _normalizeStyle(_ctx.style)
  }, [
    (_openBlock(), _createElementBlock("iframe", {
      key: _ctx.vimeoUrl,
      src: _ctx.vimeoUrl,
      class: _normalizeClass(_ctx.autoFitVideoToAspectRatioClass),
      title: _ctx.title
    }, null, 10, _hoisted_1))
  ], 4))
}